import { render } from "./feedBack.vue?vue&type=template&id=a705b0e6&scoped=true&ts=true"
import script from "./feedBack.vue?vue&type=script&lang=ts"
export * from "./feedBack.vue?vue&type=script&lang=ts"

import "./feedBack.vue?vue&type=style&index=0&id=a705b0e6&lang=scss&scoped=true"

import exportComponent from "D:\\work\\CP_new_work\\saas-h5-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a705b0e6"]])

export default __exports__